import { ReactElement } from 'react';
import { Box } from '@twilio-paste/core/box';
import { Spinner } from '@twilio-paste/core/spinner';

import { types } from './definitions';
import styles from './pageLoader.module.css';

const PageLoader = ({
  width = 'initial',
}: types.PageLoaderProps): ReactElement => (
  <Box as="main" className={styles.pageLoaderContainer} width={width}>
    <Spinner decorative={false} title="Loading" size="sizeIcon110" />
  </Box>
);

export default PageLoader;
